// Spanish translation

const es = {
  "staff_supply.request.employee.filter": "Filtrar empleado",
  "staff_supply.request.position.filter": "Filtrar cargo",
  "staff_supply.request.warehouse.filter": "Filtrar bodega",
  "staff_supply.request.reason.filter": "Filtrar motivo",
  "staff_supply.request.request_date.filter": "Filtrar fecha",
  "staff_supply.request.lines.filter": "Filtrar dotación",
  "menu.staff_supply": "DOTACIÓN PERSONAL",
  "menu.stock_equipment_product": "PRODUCTOS",
  "menu.staff_supply_stock_inventory": "INVENTARIO & STOCK",
  "staff_supply.request.number": "Número de solicitud",
  "staff_supply.request.created_date": "Fecha de Creación",
  "staff_supply.request.entry_date": "Fecha de ingreso",
  "staff_supply.request.observation": "Observación",
  "staff_supply.request.employee": "Nombre de Empleado",
  "staff_supply.request.id_number": "Cédula",
  "staff_supply.request.charge": "Cargo",
  "staff_supply.request.area": "Área",
  "staff_supply.request.business_unit": "Unidad de Negocio",
  "staff_supply.request.supplies_products": "Productos",
  "staff_supply.request.reason": "Motivo",
  "staff_supply.request.state": "Estado",
  "staff_supply.request.bonding": "Vinculación",
  "company.employee.name": "Empleado",
  "product.product": "Productos",
  "product.product.name": "Nombre del Producto",
  "product.product.type_equipment": "Tipo de dotación",
  "product.product.size": "Talla",
  "product.product.storage": "Bodegas",
  "product.product.quantity": "Cantidad",
  "product.product.available": "Disponible",
  "product.image.image_url": "URL de la imagen",
  "product.template.images.image_url": "Imagen",
  "product.product.images": "IMAGEN",
  "product.product.current_stock": "Stock actual",
  "product.product.code": "Código",
  "product.product.business_unit": "Unidad de negocio",
  "product.product.area": "Área",
  "product.product.associated_position": "Cargo Asociado",
  "menu.staff_supply_product": "Catalogo de productos",
  "menu.staff_supply_indicators": "Indicadores",
  "menu.request": "Solicitudes dotación",
  "product.product.uom": "Unidad de negocio",
  "staff_supply.request.warehouse": "Bodega",
  "staff_supply.request.request_date": "Fecha de creación",
  "staff_supply.request": "Solicitudes dotación personal",
  "staff_supply.request.employee.position.name": "Cargo",
  "staff_supply.request.employee.party.id_number": "Cedula",
  "staff_supply.request.employee.operation_center.name":
    "Centro de operaciones",
  "staff_supply.request.effective_date": "Fecha Efectiva",
  "staff_supply.request.position": "Cargo",
  "staff_supply.request.eployee.position": "Cargo",
  "staff_supply.request.employee.department.name": "Area",
  "staff_supply.request.line.product": "Nombre del producto",
  "staff_supply.request.line.warehouse": "Bodega",
  "staff_supply.request.line.type_category": "Tipo de producto",
  "staff_supply.request.line.size_category": "Talla",
  "staff_supply.request.line.gender_category": "Género",
  "staff_supply.request.line.quantity": "Cantidad",
  "staff_supply.request.line.observation": "Observación",
  "staff_supply.request.line.move": "Movimiento",
  "staff_supply.request.line.state": "Estado",
  "staff_supply.request.line": "Dotación",
  "product.template.images": "IMAGEN",
  "product.template.name": "Nombre",
  "product.template.code": "Código",
  "product.template.sale_uom": "Unidad de medida",
  "product.template.quantity": "Cantidad",
  "product.template.cost_price": "Coste",
  "product.template": "Catalogo",
  "staff_supply.request.next": "Siguiente",
  "staff_supply.request.prev": "Anterior",
  "staff.supply.no_employee": "Falta seleccionar empleado",
  "staff_supply.label.signature":
    "Las partes certifican que los elementos o documentos han sido entregados y recibidos en conformidad. La firma de quien entrega acredita el cumplimiento del proceso, y la de quien recibe confirma la recepción en buen estado.",
  "staff.supply.fields.required": "Falta completar campos requeridos",
  "staff.supply.success": "Solicitud Creada",
  "staff.supply.no_signature": "Agrega tu firma",
  "staff.supply.delivery_signature": "Firma de quien entrega",
  "staff.supply.recipient_signature": "Firma de quien recibe",
  "staff_supply.request.add_signature": "Agregar Firma",
  "staff.equipment.btn_update_signature": "Actualizar Firma",
  add_signature: "Agregar Firma",
  "Role Change": "Cambio de Rol",
  Loss: "Pérdida",
  Damage: "Daño",
  Other: "Otro",
  Onboarding: "Contratación",
  "staff_supply.btn_accept": "Aceptar",
  "staff_supply.request.line.size": "Talla",
  "staff.supply.no_product_supplies":
    "No seleccionaste ninguna dotación de producto",
  "staff.title_main":
    "Gestiona las solicitudes de dotación, consulta el catálogo disponible y revisa indicadores de entrega.",
  "staff_supply.request.waiting": "En espera",
  "staff_supply.request.done": "Terminado",
  "staff_supply.request.save": "Guardar y Finalizar",
  "staff_supply.request.create": "Crear Solicitud",
  on_time: "A tiempo",
  on_the_limit: "En el límite",
  urgent: "Urgente",
};

export default es;
